/**
 * « Vos clients ne peuvent pas vous répondre » : l'entreprise n'a pas d'e-mail.
 *
 * Devis, factures, relances et commandes partent de `no-reply@dker.pro` au
 * nom de l'entreprise, avec son e-mail en `reply_to`. Sans lui, un client qui
 * répond écrit à `no-reply` et personne ne lit sa réponse. Le formulaire des
 * paramètres l'exige désormais, mais une entreprise créée avant n'y repasse
 * pas : d'où ce bandeau, sur tous les écrans du bureau, jusqu'à ce qu'il soit
 * renseigné. Seul le patron peut le corriger ; les autres savent à qui le dire.
 */
import { Link, useLocation } from "react-router-dom";
import { MailWarning } from "lucide-react";
import { isFieldRole } from "@dker/core";
import { useAuthStore } from "@/stores/authStore";

export function ReplyEmailNotice() {
  const tenant = useAuthStore((s) => s.tenant);
  const role = useAuthStore((s) => s.user?.role);
  const { pathname } = useLocation();

  if (!tenant || tenant.email?.trim()) return null;
  if (isFieldRole(role) || role === "lecture_seule") return null;

  const estPatron = role === "patron";

  return (
    <div
      role="status"
      className="flex flex-wrap items-center gap-x-3 gap-y-2 border-b border-warning/30 bg-warning/15 px-4 py-2.5 text-sm lg:px-6"
    >
      <MailWarning size={16} className="text-warning-ink flex-shrink-0" aria-hidden />
      <p className="flex-1 min-w-[14rem] text-text-secondary">
        <span className="font-medium text-text-primary">Vos clients ne peuvent pas vous répondre.</span>{" "}
        L’entreprise n’a pas d’e-mail&nbsp;: leurs réponses à vos devis et factures se perdent.
        {!estPatron && " Le patron peut le renseigner dans les paramètres."}
      </p>
      {estPatron && pathname !== "/parametres" && (
        <Link
          to="/parametres"
          className="font-medium text-warning-ink underline underline-offset-2 hover:text-text-primary"
        >
          Renseigner l’e-mail
        </Link>
      )}
    </div>
  );
}
